import { TAddressParentTypes } from '../../generated/graphql';
import { TGiftType } from '../gifts/queries';

export const getReadableAddressParentType = (addressType?: null | TAddressParentTypes) => {
  if (addressType == null) return 'Deleted';

  switch (addressType) {
    case TAddressParentTypes.Company:
    case TAddressParentTypes.Office:
      return 'Office';
    case TAddressParentTypes.Employee:
      return 'Home';
    default:
      return undefined;
  }
};

export const getReadableDeliveryMethodType = (gift: TGiftType) => {
  const addressType = gift.address?.parentType;
  if (addressType == null) return 'Deleted';

  switch (addressType) {
    case TAddressParentTypes.Company:
      return 'Company HQ';
    case TAddressParentTypes.Office:
      return gift.employee?.office ? gift.employee?.office.name : 'Office';
    case TAddressParentTypes.Employee:
      return 'Home';
    default:
      return '';
  }
};

export const getReadableAddressProperty = (gift: any, key: string) => {
  const address = gift.address;
  if (!address || !key) return 'Not found.';
  return address.useGoogleAddress ? address.addressFromGoogle[key] : address[key];
};

export const getIconFromAddressParentType = (addressType?: null | TAddressParentTypes): string | undefined => {
  const readableType = getReadableAddressParentType(addressType);
  if (readableType == null) return undefined;

  if (readableType === 'Home') return 'home';
  else if (readableType === 'Office') return 'domain';
  else return 'close';
};

export type TIsAddressValidOptions = {
  checkGoogleValidated?: null | boolean;
  checkMissingInfo?: null | boolean;
};

export const isAddressValid = (address?: null | Record<string, any>, options?: TIsAddressValidOptions) => {
  if (!address) return false;
  const { address1, city, state, country, zipCode, addressFromGoogle, useGoogleAddress, googleValidated, missingInfo } = address;
  const isBaseAddressComplete = address1 && city && state && country && zipCode;
  const isGoogleAddressComplete = addressFromGoogle?.address1 && addressFromGoogle?.city && addressFromGoogle?.state && addressFromGoogle?.country && addressFromGoogle?.zipCode;
  //console.log('address:', address);
  //console.log('isBaseAddressComplete:', isBaseAddressComplete);
  //console.log('useGoogleAddress:', useGoogleAddress);
  //console.log('isGoogleAddressComplete:', isGoogleAddressComplete);
  let isAddressComplete = isBaseAddressComplete || (useGoogleAddress && isGoogleAddressComplete);
  if (options?.checkGoogleValidated) isAddressComplete = isAddressComplete && googleValidated;
  if (options?.checkMissingInfo) isAddressComplete = isAddressComplete && missingInfo;
  return isAddressComplete;
};
